interface IProps {
  theme: "light" | "dark";
}

export const Lock = ({ theme }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M14.2857 7.2002H13.4286V4.9502C13.4286 2.33145 10.9929 0.200195 8 0.200195C5.00714 0.200195 2.57143 2.33145 2.57143 4.9502V7.2002H1.71429C0.767857 7.2002 0 7.87207 0 8.7002V14.7002C0 15.5283 0.767857 16.2002 1.71429 16.2002H14.2857C15.2321 16.2002 16 15.5283 16 14.7002V8.7002C16 7.87207 15.2321 7.2002 14.2857 7.2002ZM10.5714 7.2002H5.42857V4.9502C5.42857 3.70957 6.58214 2.7002 8 2.7002C9.41786 2.7002 10.5714 3.70957 10.5714 4.9502V7.2002Z"
        fill="#969696"
      />
    </svg>
  );
};
